<template>
  <div>
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>My Cloud Booth</BreadcrumbItem>
          <BreadcrumbItem>Product Display</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.nameEn}}</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="$router.push('/exhibitionEn/index/proGroup/productadd')">
          <span class="htb-add">+</span>
          <span>Add group</span>
        </div>
      </div>
    </div>
    <div class="my-item">
      <div class="custom-wrap">
        <template v-if="list && list.items && list.items.length">
          <Table :border="false" :columns="columns1" :data="list.items" :disabled-hover="false">
            <template slot-scope="{ row, index }" slot="groupName">{{row.name}}</template>
            <template slot-scope="{ row, index }" slot="time">{{row.inTime | moment("YYYY/MM/DD")}}</template>
            <template slot-scope="{ row, index }" slot="action">
              <span style="color: #1890ff;cursor: pointer;" @click="view(row)">Product</span>
              <span style="display: inline-block;padding: 0 5px;">|</span>
              <span style="color: #1890ff;cursor: pointer;" @click="edit(row)">Edit</span>
              <span style="display: inline-block;padding: 0 5px;">|</span>
              <Poptip confirm ok-text="confirm" cancel-text="cancel" title="Confirm deletion?" @on-ok="delItem(row)" :transfer="true">
                <span style="color: #f00;cursor: pointer;">Delete</span>
              </Poptip>
            </template>
          </Table>
          <div class="my-page" v-if="totalCount > pageSize">
            <Page
              show-total
              show-elevator
              :page-size="pageSize"
              :current="pageIndex"
              :total="totalCount"
              @on-change="changePage"
              @on-page-size-change="changePageSize"
            />
          </div>
        </template>
        <div class="u-empty" v-else>No data</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  // 顶部banner
  name: "photo-top",
  data() {
    return {
      add: false,
      list: null,
      pageSize: 16,
      pageIndex: 1,
      totalCount: 0,
      viewFlag: false,
      editShow: false,
      editInfo: null,
      loading: false,

      columns1: [
        {
          title: "Displaying group name",
          slot: "groupName",
          key: "groupName",
          align: "center"
        },
        {
          title: "Creating date",
          slot: "time",
          key: "time",
          align: "center"
        },
        {
          title: "Operation",
          slot: "action",
          align: "center"
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition"
    }),
    option() {
      return { compId: this.company.id };
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getProductGroup: "productModule/getProductGroup",
      delProductGroup: "productModule/delProductGroup",
      editProductGroup: "productModule/editProductGroup"
    }),
    handleView(data) {
      this.viewFlag = true;
    },
    async delItem(item) {
      let result = await this.delProductGroup(item.id);
      if (result.successed) {
        this.$Message.success("successful");
        this.init();
      } else {
        this.$Message.error("fail,please try again");
      }
    },
    async init() {
      let listData = await this.getProductGroup(this.option);

      if (listData && listData.items) {
        listData.items.forEach(c => {
          try {
            c.introduction = JSON.parse(c.introduction);
          } catch (error) {
            c.introduction = {};
          }
        });
        this.list = listData;
        this.pageSize = this.list.pageSize;
        this.pageIndex = this.list.pageIndex;
        this.totalCount = this.list.totalCount;
      }
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
    },
    changeSwitch(e, data) {
      this.edit(data);
    },
    edit(item) {
      this.$router.push(`/exhibitionEn/index/proGroup/productedit?id=${item.id}`);
    },
    view(item) {
      this.$router.push(`/exhibitionEn/index/proGroup/productproList?id=${item.id}&name=${item.name}`);
    }
  }
};
</script>

<style scoped lang="scss">
.custom-wrap {
  margin: 0 auto;
  min-height: 500px;
}
</style>
